import { AppEnv } from "../consts";
import { APP_ENV } from "../config-global";
import { ErrorService } from "./errorService";
import { i18n } from '../locales'

let instanceToKeep

const waitForPayMe = () => {
    return new Promise((resolve, reject) => {
        if (window.PayMe) {
            resolve()
        } else {
            setTimeout(() => {
                waitForPayMe().then(resolve)
            }, 1000)
        }
    })
}

export const PaymentService = {
    /* PayMe Logic - https://docs.payme.io/docs/payments/5d1700d8ba5ba-hosted-fields-jsapi */
    async initPaymentForm(translate, apiKey) {

        await waitForPayMe()

        return window.PayMe.create(apiKey, { testMode: APP_ENV !== AppEnv.PROD, tokenIsPermanent: true })
            .then((instance) => {

                instanceToKeep = instance // Keep the instance because we need to use is again...
                const { EXPIRATION, NUMBER, CVC, NAME_FIRST, NAME_LAST } = window.PayMe.fields
                const fields = instance.hostedFields();
                const baseFieldOptions = {
                    styles: {
                        base: {
                            'color': '#000000',
                            'text-align': 'center',
                            'padding': '10px',
                        }
                    }
                }
                /* Create hosted fields */
                const cardNumber = fields.create(NUMBER, { ...baseFieldOptions, placeholder: translate('event_page.card_number') });
                const expiration = fields.create(EXPIRATION, { ...baseFieldOptions, placeholder: translate('event_page.card_date') });
                const cvc = fields.create(CVC, { ...baseFieldOptions, placeholder: translate('event_page.cvv_number') });
                const firstName = fields.create(NAME_FIRST, { ...baseFieldOptions, placeholder: translate('event_page.card_holder_first_name') });
                const lastName = fields.create(NAME_LAST, { ...baseFieldOptions, placeholder: translate('event_page.card_holder_last_name') });
                /* Mount fields */

                const mountingPromises = [
                    cardNumber.mount('#card-number-container'),
                    expiration.mount('#card-expiration-container'),
                    cvc.mount('#card-cvv-container'),
                    firstName.mount('#card-holder-first-name-container'),
                    lastName.mount('#card-holder-last-name-container'),
                ]
                // Return a promise that resolves when all fields are mounted
                return Promise.all(mountingPromises)
            }).catch(e => {
                // SUPER TODO.
                alert(e.message)
                console.log(e);
                ErrorService.handleError(e)
                alert(i18n.t('payment.technical_error'))
                // window.location.reload()
            })
    },

    async preparePaymentToken({ orderLabel, payerEmail, payerPhone, total, currencyCode }) {
        payerEmail = payerEmail || "hack@nimi.co.il" // this is a hack to avoid the error of missing email payme requires it but we don't need it in our system we can send tickets by sms or whatsapp
        const label = orderLabel || "Tickets Order"
        const currency = currencyCode || "ILS"
        const saleData = {
            payerEmail,
            payerPhone: payerPhone.replaceAll(" ", ""), // Remove all spaces characters
            total: {
                label,
                amount: {
                    currency,
                    value: `${(total / 100).toFixed(2).toString()}`, // should be formatted like this - '55.00',
                }
            }
        };

        return new Promise((resolve, reject) => {
            instanceToKeep.tokenize(saleData)
                .then((tokenizationResult) => {
                    resolve(tokenizationResult);
                })
                .catch((tokenizationError) => {
                    reject(tokenizationError)
                });
        })


    }
}
